import { useState } from 'react'

import { CodeBlock } from '../CodeBlock.tsx'

import {
  EXAMPLE_STATUSES,
  examplePayloadJsonFor,
  momentFor,
  type ExampleStatus,
} from './webhook-example-payloads.ts'

// The status-picker example on /docs/webhooks/payload, mounted from markdown
// via the `::webhook-payload` directive (src/docs/directives.tsx).
//
// One delivery, told status by status: picking a status swaps the JSON for the
// snapshot Curri would send at that moment, so the field lifecycle — driver
// appearing, location moving, images accumulating, deliveredAt filling in — is
// visible instead of described. The interactive lifecycle explorer on the
// Delivery lifecycle page shares the same data (webhook-example-payloads.ts).

export const WebhookPayloadExample = () => {
  const [status, setStatus] = useState<ExampleStatus>('en_route_to_destination')

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12, margin: '8px 0 16px' }}>
      <div role="group" aria-label="Example delivery status" style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        {EXAMPLE_STATUSES.map(candidate => {
          const active = candidate === status
          return (
            <button
              aria-pressed={active}
              key={candidate}
              onClick={() => setStatus(candidate)}
              type="button"
              style={{
                padding: '5px 11px',
                borderRadius: 999,
                border: `1px solid ${active ? 'transparent' : 'var(--curri-border)'}`,
                background: active ? 'var(--curri-brand-fill)' : 'var(--curri-surface)',
                color: active ? 'var(--curri-brand-on-fill)' : 'var(--curri-text-secondary)',
                fontFamily: 'var(--curri-font-mono)',
                fontSize: 12.5,
                cursor: 'pointer',
                transition: 'background 120ms var(--curri-ease), color 120ms var(--curri-ease)',
              }}
            >
              {candidate}
            </button>
          )
        })}
      </div>
      <p style={{ margin: 0, fontSize: 14, color: 'var(--curri-text-secondary)' }}>
        {momentFor(status).caption}
      </p>
      <CodeBlock code={examplePayloadJsonFor(status)} language="json" />
    </div>
  )
}
